<div class="warning-popup-container">
    <div class="warning-popup-title">
        <span class="warning-symbol">!</span>
        <h3 class="warning-popup-header">WARNING</h3>
    </div>
    <div *ngIf="data.has27Green || data.has36Green" class="warning-popup-content">
        <p *ngIf="data.course1.length > 0" class="warning-popup-text-header ">{{data.courses[0].CourseName}}</p>
        <p *ngIf="data.course1.length > 0" class="warning-popup-text"> - Green{{data.course1.length > 1 ? 's':''}}
            <span *ngFor="let green of data.course1; let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{data.course1.length > 1 ? "are": "is"}} missing the hole location
        </p>

        <p *ngIf="data.course2.length > 0" class="warning-popup-text-header ">{{data.courses[1].CourseName}}</p>
        <p *ngIf="data.course2.length > 0" class="warning-popup-text"> - Green{{data.course2.length > 1 ? 's':''}}
            <span *ngFor="let green of data.course2; let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{data.course2.length > 1 ? "are": "is"}} missing the hole location
        </p>

        <p *ngIf="data.course3.length > 0" class="warning-popup-text-header ">{{data.courses[2].CourseName}}</p>
        <p *ngIf="data.course3.length > 0" class="warning-popup-text"> - Green{{data.course3.length > 1 ? 's':''}}
            <span *ngFor="let green of data.course3; let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{data.course3.length > 1 ? "are": "is"}} missing the hole location
        </p>

        <p *ngIf="data.course4.length > 0 && data.has36Green" class="warning-popup-text-header ">{{data.courses[2].CourseName}}</p>
        <p *ngIf="data.course4.length > 0 && data.has36Green" class="warning-popup-text"> - Green{{data.course4.length > 1 ? 's':''}}
            <span *ngFor="let green of data.course4; let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{data.course4.length > 1 ? "are": "is"}} missing the hole location
        </p>
    </div>
    <div *ngIf="data.isMultiplePinsheetCourse">
        <p *ngIf="data.course1.length > 0 || data.course2.length > 0" class="warning-popup-text">Green{{(data.course1.length > 1 || data.course2.length > 1) ? 's':''}} 
            <span *ngFor="let green of (data.course1.concat(data.course2)); let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{(data.course1.length > 1 || data.course2.length > 1) ? "are": "is"}} missing the hole location
        </p>
    </div>
    <div *ngIf="!data.has27Green && !data.has36Green && !data.isMultiplePinsheetCourse">
        <p *ngIf="data.greens.length > 0" class="warning-popup-text">Green{{data.greens.length > 1 ? 's':''}} 
            <span *ngFor="let green of data.greens; let last = last">
                {{ green.Name }}<span *ngIf="!last">, </span>
            </span>
            {{data.greens.length > 1 ? "are": "is"}} missing the hole location
        </p>
    </div>
</div>

<button (click)="closeWarning()" class="warning-popup-close-btn">X
</button>
